export default {
    newDesign: true,
    parameters: {
      landing_id: "ItQRob",
      segment: 9,
    },
    title: "Corso gratuito per sviluppatori di giochi per bambini | Kodland",
    downtimeUrl: "https://www.kodland.org/it",
    startPage: {
      title:
        "Rispondi a 5 domande e ricevi un invito a un corso di programmazione GRATUITO su Roblox!",
      subtitle:
        "Tuo figlio/a creerà il proprio gioco e noi gli mostreremo come sfruttare il suo interesse per la tecnologia in modo positivo.",
      image: {
        url: "/welcome/it_quiz_rob_desk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/it_quiz_rob_mob.png",
        style: {
          width: "100%",
        },
      },
      button: " Clicca qui per iscriverti 🚀 ",
    },
    stopPage: {
      "image": "/welcome/quizV2/no-computer.png",
      "title": "Grazie per aver scelto la nostra piattaforma educativa!",
      "subtitle": "Si prega di notare che i nostri corsi richiedono una tastiera e un mouse; quindi telefoni, tablet e dispositivi privi di queste caratteristiche non sono compatibili. Per rimanere sempre aggiornato/a sulle nostre novità, puoi seguirci su <a href=\"https://www.instagram.com/kodland.it/\" target=\"_blank\">Instagram</a> 💙"
    },
    quizRotateBySteps: {
      1: {
        question: "A tuo figlio/a piace giocare a videogiochi come Roblox o Minecraft?",
        subtitle: "La risposta ci aiuterà a scegliere la corretta metodologia di insegnamento",
        answers: [
            "Sì, li adora!",
            "Qualche volta",
            "Non molto",
        ],
      },
      2: {
        question: "A tuo figlio/a piace risolvere enigmi o capire come funzionano i giochi?",
        answers: [
            "Sì, adora le sfide e gli enigmi",
            "A volte, se fa parte del gioco",
            "No, preferisce giochi più semplici",
        ],
      },
      3: {
        question: "Tuo figlio/a ha mostrato interesse nel progettare personaggi, storie o mondi?",
        answers: [
            "Sì, è molto creativo",
            "Un po’, ma ha bisogno di una guida",
            "Non molto, preferisce altre attività"
        ],
      },
      4: {
        title: "Quanti anni ha tuo figlio/a?",
        type: "age",
        button: "",
      },
      5: {
        question: "Hai un computer/portatile per studiare?",
        answers: [
          "✔️ Sì",
          {
            answer: "❌ No",
            stopAnswer: true,
          },
        ],
      },
      6: {
        title: "Congratulazioni! 🎉",
        typeInfo: "congrats",
        subtitle:
          "Clicca su '📆 Prenota una lezione' per completare la registrazione. Ti invieremo un video corso e l'accesso alla nostra piattaforma non appena riceveremo la tua richiesta.",
        button: "📆 Prenota una lezione",
      },
      7: {
        title: "Prenota una lezione gratuita",
        type: "one-page-contacts",
        subtitle: "",
        button: "👏 Perfetto. Manca l'ultimo passaggio!",
      },
      8: {
        title: "",
        type: "timeslot",
        subtitle: "",
        button: "",
      },
      9: {
        title:
          "Controlla questi dettagli per completare la registrazione ✨",
        typeInfo: "pc-laptop",
        subtitle:
          "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
        button: "Cos'altro?",
      },
      10: {
        title: "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
        typeInfo: "whatsapp",
        subtitle:
          "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
        button: "Cos'altro?",
      },
      11: {
        title: "La lezione si svolgerà sulla nostra piattaforma 💻",
        typeInfo: "classroom",
        subtitle:
          "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
        button: "Ho capito ✅",
      }
    },
  };
  
